module.exports = __webpack_public_path__ + "img/logo.2b46ae63.png";